// Inject hide styles
var style = document.createElement('style');
style.innerHTML = '.product-media-container.hide-slide { display: none !important; }';
document.head.appendChild(style);

function getColorNames() {
  try {
    var variants = ShopifyAnalytics.meta.product.variants;
    var colors = variants.map(function(v) {
      return v.public_title.split(' / ')[0];
    }).filter(function(v, i, a) {
      return a.indexOf(v) === i;
    });
    return colors;
  } catch(e) {
    return [];
  }
}

window.filterGallery = function(selectedColor) {
  var colorNames = getColorNames();

  document.querySelectorAll('slideshow-slide').forEach(function(slide) {
    var img = slide.querySelector('img');
    if (!img) return;
    var alt = (img.getAttribute('alt') || '').trim();
    if (alt === 'Size Chart' || alt === selectedColor) {
      slide.classList.remove('hide-slide');
    } else if (colorNames.indexOf(alt) > -1) {
      slide.classList.add('hide-slide');
    } else {
      slide.classList.remove('hide-slide');
    }
  });

  document.querySelectorAll('scroll-hint button').forEach(function(btn) {
    var img = btn.querySelector('img');
    if (!img) return;
    var alt = (img.getAttribute('alt') || '').trim();
    if (alt === 'Size Chart' || alt === selectedColor) {
      btn.style.removeProperty('display');
    } else if (colorNames.indexOf(alt) > -1) {
      btn.style.setProperty('display', 'none', 'important');
    } else {
      btn.style.removeProperty('display');
    }
  });
};

window.getInitialColor = function() {
  try {
    var scripts = document.querySelectorAll('script[type="application/json"]');
    var colorNames = getColorNames();
    for (var i = 0; i < scripts.length; i++) {
      var data = JSON.parse(scripts[i].textContent);
      if (data.option1 && colorNames.indexOf(data.option1) > -1) {
        return data.option1;
      }
    }
  } catch(e) {}
  return null;
};

document.addEventListener('variant:update', function(e) {
  var resource = e.detail && e.detail.resource;
  if (!resource) return;
  window.filterGallery(resource.option1);
});

window.addEventListener('load', function() {
  var color = window.getInitialColor();
  if (color) window.filterGallery(color);
});
